<template>
  <v-app>
    <v-toolbar
      color="primary"
      dark
      fixed
      app
      v-if="hasToken"
    >
      <router-link to="/">
        <div class="header__logo logo logo--wcz"></div>
      </router-link>

      <v-spacer></v-spacer>
      <v-toolbar-side-icon
        v-show="hasToken"
        @click.stop="menu = !menu"
      ></v-toolbar-side-icon>
    </v-toolbar>
    <v-content :class="{'pb-5': isAuthenticated && $vuetify.breakpoint.smAndDown}">
      <router-view></router-view>
    </v-content>
    <v-bottom-nav
      fixed
      :value="isAuthenticated && $vuetify.breakpoint.smAndDown"
    >
      <v-btn
        color="primary"
        flat
        to="/dashboard"
      >
        <span v-t="'menu.overview'"></span>
        <v-icon>fa-columns</v-icon>
      </v-btn>

      <v-btn
        color="primary"
        flat
        to="/geschiedenis"
      >
        <span v-t="'menu.history'"></span>
        <v-icon>fa-chart-line</v-icon>
      </v-btn>

      <v-btn
        color="primary"
        flat
        to="/profiel"
      >
        <span v-t="'menu.myInfo'"></span>
        <v-icon>fa-user</v-icon>
      </v-btn>
    </v-bottom-nav>
    <main-navigation v-model="menu" />
  </v-app>
</template>

<script>
import MainNavigation from '@/components/MainNavigation.vue';

export default {
  components: {
    MainNavigation,
  },

  data() {
    return {
      menu: false,
    };
  },

  computed: {
    isAuthenticated() { return this.$store.state.account.isAuthenticated; },

    hasToken() { return !!this.$store.state.account.tokens.access_token; },

    isSignedIn() {
      const { isAdmin, userToken } = this.$store.state.account;

      if (isAdmin) return !!userToken;

      return this.isAuthenticated;
    },
  },
};
</script>


<style lang="scss">
@import "~chartist/dist/scss/chartist.scss";

.logo {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;

  &--wcz {
    background-image: url("assets/hoco/wocozon.png");
    width: 120px;
    height: 60px;
  }
}
@import url("https://fonts.googleapis.com/css?family=PT+Sans");

.v-icon {
  font-size: 16px;
}

// *,
// .headline,
// .display-1 {
//   font-family: 'PT Sans', 'Roboto', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
// }
</style>
